export default __webpack_public_path__ + "static/media/LatheImg.df6e2c73.jpg";